import { ValidationProvider, ValidationObserver, extend, setInteractionMode } from 'vee-validate';
import {
    between,
    required,
    email,
    confirmed,
    max,
    min,
    min_value,
    numeric,
    required_if,
} from 'vee-validate/dist/rules';

import { useVueI18n } from '@/composables/useVueI18n';

// eslint-disable-next-line import/exports-last
export const passwordValidator = (value) => {
    if (String(value).length < 8) {
        return 'Must be at least 8 characters long.';
    }

    if (/([a-z])/.test(String(value)) < 1) {
        return 'Must contain lowercase letters.';
    }

    // eslint-disable-next-line
    let specRequirement = String(value).match(/([^a-z])/g);

    if (specRequirement === null || specRequirement.length < 2) {
        return 'Must contain two capital letters, numbers or symbols.';
    }

    return true;
};

export function setupValidation() {
    setInteractionMode('lazy');

    const translator = useVueI18n();

    extend('password', { validate: passwordValidator });

    extend('required', {
        ...required,
        message: (_, values) => String(translator.t('validations.messages.required', values)),
    });

    extend('email', {
        ...email,
        message: (_, values) => String(translator.t('validations.messages.email', values)),
    });

    extend('confirmed', {
        ...confirmed,
        message: (_, values) => String(translator.t('validations.messages.confirmed', values)),
    });

    extend('numeric', {
        ...numeric,
        message: (_, values) => String(translator.t('validations.messages.numeric', values)),
    });

    extend('between', {
        ...between,
        message: (_, values) => String(translator.t('validations.messages.between', values)),
    });

    extend('max', {
        ...max,
        message: (_, values) => String(translator.t('validations.messages.max', { length: values.length })),
    });

    extend('min', {
        ...min,
        message: (_, values) => String(translator.t('validations.messages.min', { length: values.length })),
    });

    extend('required_if', {
        ...required_if,
        message: (_, values) => String(translator.t('validations.messages.required', values)),
    });

    extend('min_value', {
        ...min_value,
        message: (_, values) => String(translator.t('validations.messages.min_value', values)),
    });

    extend('callingCode', {
        message: String(translator.t('validations.messages.calling_code')),
        validate: (value) => /^\+[0-9]+$/.test(String(value)),
    });
}

// eslint-disable-next-line import/no-default-export
export default {
    install(vm) {
        vm.component('ValidationProvider', ValidationProvider);
        vm.component('ValidationObserver', ValidationObserver);
    },
};
